/** 页面信息 */
const page = new (function () {
  this.title = '实施限制生产、停产'
  this.icon = 'iconfont iconicon_group'
  this.name = 'query_xztc'
  /**菜单编号 */
  this.code = 'query_xzcf'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/query/xztc'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
